import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import StickyEnquireCTA from "@/components/StickyEnquireCTA";
import { injectJsonLd, ORG_SCHEMA, WEBSITE_SCHEMA } from "@/seo/seoService";

// Corporate training track sub-pages (not the case-studies/use-case detail
// pages under the same /corporate-training/ prefix) end in the same dark
// CTA band as the homepage/about page, so they get the same tightened
// footer top padding.
const CORPORATE_TRACK_PATHS = new Set([
  "/corporate-training/sap",
  "/corporate-training/workday",
  "/corporate-training/ai",
  "/corporate-training/ai-leadership",
]);

export default function Layout({ children }) {
  const { pathname } = useLocation();

  // The admin console (/admin, /login) is a standalone internal surface: it
  // renders its own top bar, so the public site chrome (header nav, footer,
  // WhatsApp sticky CTA) is hidden there.
  const isAdminChrome = pathname === "/admin" || pathname === "/login";

  // Scroll to top on route change.
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  // Global JSON-LD: Organization + Website (kept across routes).
  useEffect(() => {
    injectJsonLd("org-schema", ORG_SCHEMA);
    injectJsonLd("website-schema", WEBSITE_SCHEMA);
  }, []);

  if (isAdminChrome) {
    return (
      <main id="main" className="min-h-screen">
        {children}
      </main>
    );
  }

  return (
    <>
      <Header />
      <main id="main" className="min-h-[60vh]">
        {children}
      </main>
      <Footer topPaddingClass={
        pathname === "/" || pathname === "/about-us" || CORPORATE_TRACK_PATHS.has(pathname)
          ? "pt-6 lg:pt-8"
          : undefined
      } />
      <StickyEnquireCTA />
    </>
  );
}
